import "./tooltip.scss"

import { CButton } from "@coreui/react"
import Info from "assets/icons/info.svg"
import MediaProvider from "components/common/Context/MediaContext"
import PropTypes from "prop-types"
import React, { useContext } from "react"

export default function Tooltip({
  className = "",
  text,
  heading,
  disabled,
  containerClass = "",
  children,
  zIndex,
  imageClassName = "",
  position = "bottom"
}) {
  const { isSmallScreen } = useContext(MediaProvider)

  if (children) {
    return (
      <div className={`${className} ${!disabled ? "custom-tooltip" : ""}`}>
        {children}
        <div
          className={`${containerClass} ${
            disabled ? "d-none" : ""
          } tooltip-container bg-white p-3 ${position}`}
          style={{ zIndex: zIndex || "" }}
        >
          {heading && (
            <p className="font-weight-bold text-left mb-1">{heading}</p>
          )}
          <div className="content-body">{text}</div>
        </div>
      </div>
    )
  }

  if (isSmallScreen) {
    return null
  }

  return (
    <div className={`${className} custom-tooltip`}>
      <CButton
        className="p-0 m-0 h-100 d-flex align-items-center"
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={Info}
          alt="info"
          className={`tooltip-info-icon ${imageClassName}`}
        />
      </CButton>
      <div
        className={`${containerClass} p-3 bg-white tooltip-container ${position}`}
      >
        {heading && (
          <p className="font-weight-bold text-left mb-1">{heading}</p>
        )}
        <div className="content-body">{text}</div>
      </div>
    </div>
  )
}

Tooltip.propTypes = {
  className: PropTypes.string,
  text: PropTypes.node,
  heading: PropTypes.string,
  disabled: PropTypes.bool,
  containerClass: PropTypes.string,
  children: PropTypes.node,
  zIndex: PropTypes.number,
  imageClassName: PropTypes.string,
  position: PropTypes.string
}
